/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";

export const ReviewHeader = styled.span`
  font-weight: 500;
  line-height: 120%;
  font-size: 14px;
  display: flex;
  color: #9eafb1;
  justify-content: space-between;
`;
